import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'dashboardClicksOnLinksByPeriod.list'

const DashboardClicksOnLinksByPeriodListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DashboardClicksOnLinksByPeriodListSlice
